import React from 'react'
import { notifyInfo, notifyError, copyToClipboard } from 'utils'
import CopyIcon from 'assets/shared/icons/copy.svg'
import './CopyButton.scss'

type CopyButtonProps = {
  text: string
  className?: string
  style?: React.CSSProperties
  title?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  className,
  style,
  title = 'Copy'
}) => {
  const handleCopyClick = async () => {
    const copied = await copyToClipboard(text)
    if (copied) {
      notifyInfo('Copied to Clipboard', { containerId: 'modalToast' })
    } else {
      notifyError('Could not copy to clipboard', { containerId: 'modalToast' })
    }
  }

  return (
    <button
      type="button"
      className={className ? `copy-button ${className}` : 'copy-button'}
      style={style}
      onClick={handleCopyClick}
      data-testid="copy-button"
      title={title}
      aria-label={title}
    >
      <img src={CopyIcon} alt="copy" />
    </button>
  )
}

export default CopyButton
